import { render, staticRenderFns } from "./ClientPermitIpSetting.vue?vue&type=template&id=4555f335&scoped=true"
import script from "./ClientPermitIpSetting.vue?vue&type=script&lang=js"
export * from "./ClientPermitIpSetting.vue?vue&type=script&lang=js"
import style0 from "./ClientPermitIpSetting.vue?vue&type=style&index=0&id=4555f335&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555f335",
  null
  
)

export default component.exports